import GetApp from './homeLandingPage/GetApp';
import React, { useEffect, useState } from 'react';
import FeaturesBar from './homeLandingPage/FeaturesBar';
import IntroSection from './homeLandingPage/IntroSection';
import { useLocation, useNavigate } from 'react-router-dom';
import LandingHeader from './homeLandingPage/LandingHeader';
import { HomeHeroBanner } from './homeLandingPage/HomeHeroBanner';
import { AboutSection } from './homeLandingPage/aboutSection/AboutSection';
import DeliveryBanner from './homeLandingPage/DeliveryBanner';
import RecentlyViewedProducts from './homeLandingPage/RecentlyViewedProducts';
import PopularCategories from './homeLandingPage/popularProductsCategories/PopularCategories';
import { DirectDebitBankSetupSuccessModal } from '../checkoutItems/directDebitSetup/directDebitBankSetUp/DirectDebitBankSetupSuccessModal';

const Home = () => {
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    if (location.state?.showSuccessModal) {
      setShowModal(true);
      navigate(location.pathname, { replace: true });
    }
  }, [location.state]);

  const features = [
    {
      icon: '/images/split.svg',
      text: 'Split your payment',
    },
    {
      icon: '/images/fee.svg',
      text: 'No hidden fees',
    },
    {
      icon: '/images/calendar-update.svg',
      text: 'Flexible plans',
    },
    {
      icon: '/images/delivery-truck.svg',
      text: 'Receive immediately',
    },
  ];
  return (
    <div>
      <LandingHeader
        isDropdownOpen={isDropdownOpen}
        setIsDropdownOpen={setIsDropdownOpen}
      />
      <DirectDebitBankSetupSuccessModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onGotoPurchases={() => {
          navigate('/user-dashboard/shopping-overview/purchases');
        }}
      />
      <main>
        <div>
          <HomeHeroBanner />
        </div>
        <div className="pt-8 mx-5">
          <IntroSection />
          <FeaturesBar
            features={features}
            // containerClass="bg-[#F5F5F7]"
            textClass="font-medium"
          />
        </div>
        <PopularCategories />
        <AboutSection />
        <DeliveryBanner />
        <div className="mx-5">
          <RecentlyViewedProducts />
        </div>
        <GetApp />
      </main>
    </div>
  );
};

export default React.memo(Home);
